<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-22 15:54:18
 * @LastEditors: Please set LastEditors
 -->

<template>
    <div class="content" v-loading="loading">
        <div class="pageTitle">{{pageTitle}}</div>
        <div class="formArea">
            <el-form ref="form" :model="form" :rules="rules" label-width="160px">
                <el-form-item label="发货单号:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form.stock_out_sn" :readonly="is_edit"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="经销商信息:">
                    {{outwarehousesData.to_sn}}
                </el-form-item>
                <el-form-item label="出库仓库:">
                    <el-select v-model="form.warehouse_sn" size="small" :disabled="disable" @change="changeWare">
                        <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                   :value="i.warehouse_sn"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否赠品:">
                    <span v-if="outwarehousesData.isgift == 1">赠品</span>
                    <span v-if="outwarehousesData.isgift == 2">非赠品</span>
                </el-form-item>
                <el-form-item label="出货时间" prop="stock_out_time">
                    <el-col :span="8">
                        <el-date-picker type="date" placeholder="选择日期" v-model="form.stock_out_time"
                                        style="width: 100%;"></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="收货地址:">
                    {{outwarehousesData.to_address}}
                </el-form-item>
                <el-form-item v-if="outwarehousesData.order_notes" label="订单留言:">
                    {{outwarehousesData.order_notes}}
                </el-form-item>
                <el-form-item label="备注:">
                    <el-col :span="8">
                        <el-input v-model="form.remarks"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item :label="tableLabelName">
                    <el-table
                    ref="multipleTable"
                    :data="tableData"
                    height="250"
                    border
                    stripe
                    @selection-change="checkStockoutnum"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        width="50"
                        fixed 
                        >
                </el-table-column>
                
                <el-table-column
                        prop="product_sn"
                        width="180"
                        label="产品编号"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        width="120"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_specs"
                        label="产品规格"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="attribute_name"
                        label="商品属性"
                        width="180"
                        show-overflow-tooltip>
                </el-table-column>
                
                <el-table-column
                        prop="stock_out_num"
                        label="订单应发数量"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="real_stock_out_num"
                        label="剩余应发数量"
                        width="180"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="stock_out_num_date"
                        label="本次实发数量"
                        width="180"
                        show-overflow-tooltip
                        v-if="isCodeShow == false"
                        >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.stock_out_num_date"
                                    type="number"
                                    :disabled ="scope.row.disableStatus"
                                    class="grayBg"
                                    @input="change(scope.$index)"
                                    >
                            </el-input>
                        </template>
                </el-table-column>
                <el-table-column
                        prop=""
                        label="操作"
                        width="180"
                        show-overflow-tooltip
                        v-if="isCodeShow == true">
                    <template slot-scope="scope" v-if="isCodeShow == true">
                        <el-button type="text" size="small" @click='addbatchShow(scope.$index)'>添加生产批次</el-button>
<!--                         <el-button type="text" size="small" @click="del(scope.row,scope.$index)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="count_out_num_box">订单剩余应发总数：{{count_out_num}}</div>
                </el-form-item>
            </el-form>

            <!-- 开启产品批次控制 - 数据 -->
            <div class="" v-if="isCodeShow == true">
                <el-table
                        ref="multipleTable"
                        :data="tableDataBatch"
                        height="250"
                        border
                        stripe
                        style="width: 100%;">
                    <!-- <el-table-column
                            type="selection"
                            width="50"
                            fixed 
                            >
                    </el-table-column> -->
                    
                    <el-table-column
                            prop="production_batch"
                            width="180"
                            label="生产批次"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="product_sn"
                            label="产品编号"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="product_name"
                            label="产品名称"
                            width="180"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="product_specs"
                            label="产品规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                                prop="stock_out_num_date"
                                label="本次发货数量"
                                width="180"
                                show-overflow-tooltip
                                >
                                <template slot-scope="scope">
                                <el-input v-model="scope.row.stock_out_num_date"
                                        type="number"
                                        :disabled ="scope.row.disableStatus"
                                        class="grayBg"
                                        @input="change(scope.$index)"
                                        >
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop=""
                                label="操作"
                                width="180"
                                show-overflow-tooltip
                                v-if="isCodeShow == true">
                            <template slot-scope="scope" v-if="isCodeShow == true">
                                <el-button type="text" size="small" @click="delTableData(scope.row,scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                </el-table>


            </div>
            <!-- 开启产品批次控制 - 数据 -->
            <el-button type="primary" @click="save('form')" style="margin: 20px">保存</el-button>
        </div>

        <el-dialog
    title="添加产品批次"
    :visible.sync="dialogVisible"
    width="30%"
    >
       <el-form ref="formProduct" v-model="formProduct">
              <el-form-item label="出货产品:">
                  <el-row>
                      <el-col :span='11'><el-input v-model="formProduct.product_sn"></el-input></el-col>
                  </el-row>
            </el-form-item>
              <el-form-item label="生产批次号:">
                <el-col :span='6'>
                    <el-input v-model="formProduct.production_batch" readonly style="float:left;"></el-input>
                    
                </el-col>
                <el-col :span='1' style="text-align:center">-</el-col>
                <el-col :span='4'><el-button type="primary"  style="float:left;" @click='addbatch()'>选择</el-button></el-col>
            </el-form-item>
              <el-form-item label="出货数量:">
                  <el-col :span='11'><el-input v-model="formProduct.stock_out_num_date"></el-input></el-col>
            </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confrimBatch">确 定</el-button>
    </span>
    </el-dialog>



        <!--添加产品-->
        <product
                v-if="addProductDialog"
                v-on:handleClose='addProductDialog = false'
                @pushData="getProInfo"
                :editInfo="formProduct"
                :type="type"
                :tableData="tableData"
                :editIndex="editIndex"
                :stock_out_sn="stock_out_sn"
                @refresh="getProList()"
        >
        </product>
        <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getSelectinfo"
        >
        </selectRole>
    </div>
</template>

<script>
    import product from './product.vue'
    import selectRole from '../../common/selectRole';

    export default {
        name: "addDeliver",
        data() {
            return {
                is_edit:false,
                loading:false,
                is_edit:false,
                pageTitle: '添加发货',
                selectRoleDialog: false,//选择门店/经销商
                addProductDialog: false,//添加产品弹窗
                form: {
                    stock_out_sn: '',
                    warehouse_sn: '',
                    to_type: '',
                    to_sn: '',
                    to_name: '',
                    to_address: '',
                    stock_out_time: '',
                    isgift: '',
                    remarks: '',
                },
                formProduct:{
                    product_sn: '',
                    production_batch: '',
                    stock_out_num_date: '',
                    specs: '',
                    product_name: '',
                    max: 0,
                },
                rules: {
                    stock_out_time: [
                        {required: true, message: '请选择出货时间', trigger: 'blur'}
                    ],
                    to_sn: [
                        {required: true, message: '请填写经销商/门店信息', trigger: 'blur'}
                    ],
                    stock_out_sn: [
                        {required: true, message: '请填写发货单号', trigger: 'blur'}
                    ]

                },
                stockArray: '',//仓库数组
                deliverType: [
                    {
                        id: 1,
                        name: '总部'
                    },
                    {
                        id: 2,
                        name: '经销商'
                    },
                    {
                        id: 3,
                        name: '门店'
                    }
                ],//发货单位
                tableData: [],
                tableDataBatch: [],
                tableLabelName: '发货产品：',
                editData: {},//新增出库，修改添加产品时的编辑的点击表格行的数据
                type: 0,//判断是编辑还是新增（0常规添加，1表示修改，2表示修改添加，3表示详情时的修改）
                editIndex: -1,//新增出库单编辑但产品信息的时候使用
                stock_out_sn: '',//保存编辑的出库单号
                isCodeShow: true,//控制生产批次号是否显示
                disable:false,
                order_line_no:'',
                outwarehousesData:[],
                orderOutwarehouse:[],
                upTableData : [],
                count_out_num: 0,
                dialogVisible:false,
            }
        },
        methods: {
            //获取基础配置
            getConfigInfo() {
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if (res.data.production_batch_on_off == 0) {
                        this.isCodeShow = false;
                    } else if (res.data.production_batch_on_off == 1) {
                        this.isCodeShow = true;
                        this.tableLabelName = '产品清单：';

                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //获取在线订单 - 基本信息
            getDDOrderInfo() {
                this.order_line_no = this.$route.query.order_line_no;
                var that = this;
                this.$get('logistics', '/dealers.orders/'+ this.order_line_no , {
                    lang: ''
                }).then(res => {
                    that.outwarehousesData = res.data;
                    that.tableData = res.data.products;
                    that.setTableDataStockoutnum();
                    that.orderOutwarehouse = res.product_batchs;
                    console.log(that.tableData);
                }).catch(function (error) {
                    console.log(error);
                });
                
            },
            /*生成随机发挥单号*/
            randomCode() {
                var randomNum = Math.floor(Math.random() * 9999);
                var myDate = new Date();
                var tY = myDate.getFullYear();
                var tM = myDate.getMonth() + 1;
                if (tM >= 1 && tM <= 9) {
                    tM = "0" + tM;
                }
                var tD = myDate.getDate();
                if (tD >= 1 && tD <= 9) {
                    tD = "0" + tD;
                }
                this.form.stock_out_sn = 'CH' + tY + tM + tD + randomNum;
            },
            //获取选择经销商门店
            getSelectinfo(val) {
                console.log(val);
                if (val.dealer_sn) {
                    this.form.to_sn = val.dealer_sn;
                    this.form.to_name = val.dealer_name;
                    this.form.to_type = 2;//经销商
                    this.form.to_address = val.dealer_address;//经销商
                } else {
                    this.form.to_sn = val.shop_sn;
                    this.form.to_name = val.shop_name;
                    this.form.to_type = 3;//门店
                    this.form.to_address = val.address;//经销商

                }
            },
            //获取选择选择的产品的信息
            getProInfo(val) {
                this.formProduct.production_batch = val.production_batch;
            },
            //选择经销商/门店
            selectCustomer() {
                this.selectRoleDialog = true;
            },
            //编辑进入页面请求单产品的列表数据
            getProList() {
                if (this.$route.query.stock_out_sn) {
                           this.disable=true
                    //编辑页面获取产品列表
                    let requestUrl = '/outwarehouses/' + this.$route.query.stock_out_sn + '/products';
                    this.$get('logistics', requestUrl, {}).then(res => {
                        this.tableData = res.data;
                         res.data.forEach(element => {
                             if(element.real_stock_out_num!=0){
                                 this.disable=true
                             }
                        });
                        // real_stock_out_num
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取仓库
            getStock() {
                this.$get('logistics', '/warehouses.all', {
                    lang: ''
                }).then(res => {
                    this.stockArray = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        if (res.data[i].is_default == 1) {
                            this.form.warehouse_sn = res.data[i].warehouse_sn;
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //确定是否是进入编辑页面
            isEditPage() {
                if (this.$route.query.stock_out_sn) {
                    this.form.stock_out_sn = this.$route.query.stock_out_sn;
                    this.stock_out_sn = this.$route.query.stock_out_sn;
                    let url = '/outwarehouses/' + this.$route.query.stock_out_sn;
                    this.$get('logistics', url, {}).then(res => {
                        this.form.warehouse_sn = res.data.warehouse_sn;
                        this.form.to_sn = res.data.to_sn;
                        this.form.to_name = res.data.to_name;
                        this.form.to_address = res.data.to_address;
                        this.form.stock_out_time = res.data.stock_out_time;
                        this.form.remarks = res.data.remarks;
                        this.form.to_type = res.data.to_type;
                        if (res.data.isgift==1) {
                            this.form.isgift = true;
                        } 
                        // else {
                        //     this.form.isgift = false;
                        // }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //添加产品
            addProduct() {
                this.type = 0;
                //如果有出库单号，需要单条添加记录
                if (this.$route.query.stock_out_sn) {
                    this.type = 2;
                }
                this.addProductDialog = true;
            },
            changeWare(){
              
                // this.tableData=[]
            },
            //添加生产批次
            addbatch() {
                //如果有参数表示是编辑单产品，此时表示编辑页面的编辑type的值为3
                this.editData = this.formProduct;
                this.type = 1;
                this.addProductDialog = true;
            },
            //修改
            edit(index) {
                //如果有参数表示是编辑单产品，此时表示编辑页面的编辑type的值为3
                if (this.$route.query.stock_out_sn) {
                    this.editData = this.tableData[index];
                    this.editIndex = index;
                    this.type = 3;
                    this.addProductDialog = true;
                    return;
                }
                this.editData = this.tableData[index];
                this.editIndex = index;
                this.type = 1;
                this.addProductDialog = true;
            },
            //删除
            del(row, index) {


                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //先判断是否进入编辑
                    if (this.$route.query.stock_out_sn) {
                        let url = '/outwarehouses/' + this.$route.query.stock_out_sn + '/products/' + row.id;
                        this.$delete('logistics', url, {
                            lang: '',
                            _method: 'delete'
                        }).then(res => {
                            this.getProList();
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                        return;
                    }
                    this.tableData.splice(index, 1);

                }).catch(error => {
                    /*this.$message({
                        type: 'error',
                        message: error.message
                    });*/

                });


            },
            //删除
            delTableData(row, index) {
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //先判断是否进入编辑
                    this.tableDataBatch.splice(index, 1);

                }).catch(error => {

                });


            },
            //保存
            save(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.isCodeShow){
                            this.upTableData = this.tableDataBatch;
                        } else {
                            if( !this.checkTableDataStockoutnum() ){
                                this.$message({
                                    message: '产品数量超过剩余发货数',
                                    type: 'warning'
                                });
                                return;
                            }
                        }
                        
                        if (this.upTableData.length < 1) {
                            this.$message({
                                message: '至少添加一件产品记录！',
                                type: 'warning'
                            });
                            return;
                        }
                        
                        //处理产品编号
                        let productArr = [], stockoutArr = [], isgift, production_batch = [];
                        for (var i = 0; i < this.upTableData.length; i++) {
                            productArr.push(this.upTableData[i].product_sn);
                            if(this.isCodeShow){
                                production_batch.push(this.upTableData[i].production_batch);                                
                            }
                            stockoutArr.push(this.upTableData[i].stock_out_num_date);
                        }
                        if (this.form.isgift) {
                            isgift = 1;
                        } else {
                            isgift = 2;
                        }
                        
                        this.loading = true;
                        
                        //console.log(stockoutArr);
                        this.$post('logistics', '/order.outwarehouses', {
                            lang: '',
                            stock_out_sn: this.form.stock_out_sn,
                            warehouse_sn: this.form.warehouse_sn,
                            // to_type: this.form.to_type,
                            // to_sn: this.form.to_sn,
                            // to_name: this.form.to_name,
                            // to_address: this.form.to_address,
                            stock_out_time: this.moment(this.form.stock_out_time).format("YYYY-MM-DD"),
                            remarks: this.form.remarks,
                            // isgift: isgift,
                            product_sn: productArr,
                            stock_out_num: stockoutArr,
                            production_batch: production_batch,
                            order_line_no: this.order_line_no,
                        }).then(res => {
                            this.loading = false;
                            if (res.message == '操作成功') {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'deliverManage'
                                });
                            }
                        }).catch(error => {
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            setTableDataStockoutnum(){
                for(var i = 0; i < this.tableData.length; i++){
                    this.tableData[i]['real_stock_out_num'] = this.tableData[i]['stock_out_num'] - this.tableData[i]['real_stock_out_num'];
                    this.tableData[i]['stock_out_num_date'] = this.tableData[i]['real_stock_out_num'];
                    this.count_out_num += this.tableData[i]['real_stock_out_num'];
                    if( this.tableData[i]['stock_out_num_date'] > 0 ){
                        this.tableData[i]['disableStatus'] = false;
                    }else{
                        this.tableData[i]['disableStatus'] = true;
                    }

                }
            },
            checkTableDataStockoutnum(){
                this.upTableData = this.$refs.multipleTable.selection;
                for(var i = 0; i < this.upTableData.length; i++){
                    if( this.tableData[i]['stock_out_num_date'] > this.tableData[i]['real_stock_out_num'] ){
                        return false;
                    }
                }
                return true;
            },
            checkStockoutnum:function(){
                this.upTableData = this.$refs.multipleTable.selection;
                this.count_out_num = 0;
                
                for(var i = 0; i < this.tableData.length; i++){
                    this.count_out_num += this.tableData[i]['real_stock_out_num'];
                    for(var j = 0; j < this.upTableData.length; j++){
                        if( this.upTableData[j]['product_sn'] == this.tableData[i]['product_sn'] ){
                            this.count_out_num -= this.tableData[j]['stock_out_num_date'];
                        }
                        
                    }
                }
            },
            onExchangeChange: function (index) {
                let tmpObj = this.tableData[index];
                this.$set(this.tableData, index, tmpObj);
            },
            change: function (index) {
                console.log("exchange price change");
                // 重新赋值
                let tmpObj = this.tableData[index];
                this.$set(this.tableData, index, tmpObj);
            },
            addbatchShow( index ){
                this.formProduct.stock_out_num_date = '';
                this.formProduct.production_batch = '';
                this.formProduct.product_sn = this.tableData[index]['product_sn'];
                this.formProduct.product_name = this.tableData[index]['product_name'];
                this.formProduct.specs = this.tableData[index]['specs'];
                this.formProduct.max = this.tableData[index]['real_stock_out_num'];
                this.dialogVisible = true;
            },
            // 确定 商品
            confrimBatch(){
            if(this.formProduct.stock_out_num_date==0){
                    this.$message({
                                    type: 'error',
                                    message: '出货数量不能为0'
                                });
                return;
            }
            let count_num = 0;
            this.count_out_num = 0;
            for(var i = 0; i < this.tableData.length; i++){
                this.count_out_num += this.tableData[i]['real_stock_out_num'];
                count_num = this.tableData[i]['real_stock_out_num'];
                
                for(var j = 0; j < this.tableDataBatch.length; j++){
                    if( this.tableDataBatch[j]['product_sn'] == this.tableData[i]['product_sn'] && this.tableDataBatch[j]['product_sn'] == this.formProduct.product_sn ){
                        console.log(this.tableDataBatch[j]['product_sn'] +'---'+ this.formProduct.product_sn);
                        count_num -= this.tableDataBatch[j]['stock_out_num_date'];
                        this.count_out_num -= this.tableDataBatch[j]['stock_out_num_date'];
                    }
                    
                }
                
                if( this.formProduct.product_sn == this.tableData[i]['product_sn'] ){
                    count_num -= this.formProduct.stock_out_num_date;
                }
                if( count_num < 0 ){
                    this.$message({
                        type: 'error',
                        message: '超过最大值'
                    });
                    return
                }

            }
            
                let aa = this.formProduct;
                this.dialogVisible = false
                this.tableDataBatch.push(this.formProduct)
                // this.batch=this.Unique(this.batch,'product_sn','production_batch')
                // this.Calcula()
                this.formProduct={
                    product_sn: '',
                    production_batch: '',
                    stock_out_num_date: '',
                    specs: '',
                    product_name: '',
                    max: 0,
                }
            },
        },
        created() {
            if (this.$route.query.stock_out_sn) {
                this.pageTitle = '修改发货';
                this.is_edit = true;
            }
            this.randomCode();
            this.getStock();
            this.getConfigInfo();
            //确定进入到编辑页面
            this.isEditPage();
            this.getProList();
            this.getDDOrderInfo();

        },
        components:{
            product
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        .formArea {
            margin: 20px;
        }
        .count_out_num_box{
            color:red;
            margin-left: 5%;
            margin-top:10px;
            font-size: 14px;
        }
    }

</style>